export const BUDGET = 'budget'
export const NAME = 'name'
